<form [formGroup]="menuService?.form" (ngSubmit)="saveAndContinue()" class="px-0 px-sm-3"
    [ngClass]="{ 'py-5 position-relative': isDialog }">
    <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" *ngIf="isDialog"
        (click)="dialogRef.close()"></i>
    <div class="container-fluid">
        <h4 class="text-bold text-center px-3">
            Candado Satelital
        </h4>

        <div class="row">
            <p class="col-md-12 text-bold">Tipo de candado</p>
            <app-autocomplete-satellite-lock-type class="col-md-6" [inputFormControl]="satelliteLockType"
                [options]="optionsSatelliteLockType" [validate]="formValidate">
            </app-autocomplete-satellite-lock-type>
        </div>

        <!-- Action buttons -->
        <div class="button-container mt-4">
            <button mat-raised-button color="primary" class="button-width-auto primary-secondary button-small"
                [ngClass]="{'warn': true}" type="button" (click)="backToPreviousStep()">
                <span class="mat-button-wrapper">Atras</span>
            </button>
            <button class="mx-2" type="submit" mat-raised-button color="accent" *ngIf="canEditSatelliteLock">
                Guardar y Continuar
            </button>
            <button class="mx-2" type="button" mat-raised-button color="accent" (click)="continueToNextStep()"
                *ngIf="!canEditSatelliteLock">
                Continuar
            </button>
        </div>
    </div>
</form>